<template>
  <div class="trial">
    <span id="u-add-up">
      <TrialAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
      />
    </span>
    <va-card :title="$t('trial.cards.title')">
      <template slot="actions">
        <va-button
          @click="open"
          href='#u-add-up'
          icon="fa fa-plus"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="trials"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="codigo" slot-scope="props">
          <va-popover :message="`${$t('trial.headings.copyLink')}`" placement="bottom">
            <span
              class="copy-link"
              @click="copiarLink(props.rowData.codigo)"
              style="cursor: pointer; color: #42b983;"
            >
              https://s1live.com/trial/{{ props.rowData.codigo }}
            </span>
          </va-popover>
        </template>
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('trial.cards.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href='#u-add-up'
              @click="update(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import TrialAddUpdate from '../trial/TrialAddUpdate.vue'
const perPage = 10
export default {
  name: 'trial',
  components: { TrialAddUpdate },
  methods: {
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.trials.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    async copiarLink (codigo) {
      const url = `https://s1live.com/trial/${codigo}`

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url)
        } else {
          const textarea = document.createElement('textarea')
          textarea.value = url
          textarea.style.position = 'absolute'
          textarea.style.left = '-9999px'
          document.body.appendChild(textarea)
          textarea.select()
          document.execCommand('copy')
          document.body.removeChild(textarea)
        }
        this.showToast(
          this.$t('trial.headings.copyLinkSuccess'),
          {
            icon: 'fa-check',
            position: 'top-right',
            duration: 1000,
            fullWidth: false,
          },
        )
      } catch (err) {
        console.error('Erro ao copiar:', err)
      }
    },
  },
  data () {
    return {
      trials: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      titleCard: '',
      updateData: null,
    }
  },
  apollo: {
    trials: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2) {
        trials: trial(limit: $perPage, offset: $page, order_by: {id: desc}) {
          id
          descricao
          codigo
          expiration_date
          qtd
          partner {
            id
            name
          }
          clients
        }
      }
      `,
      variables: {
        perPage,
        page: 0,
      },
    },
    pages: gql`
    query MyQuery {
      pages: trial_aggregate {
        aggregate {
          count
        }
      }
    }
    `,
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      const moment = this.$moment
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'partner.name',
        title: this.$t('trial.headings.partner'),
      }, {
        name: 'descricao',
        title: this.$t('trial.headings.description'),
      }, {
        name: '__slot:codigo',
        title: this.$t('trial.headings.link'),
        width: '50px',
      }, {
        name: 'qtd',
        title: this.$t('trial.headings.amount'),
        dataClass: 'text-center',
        titleClass: 'text-center',
      },
      {
        name: 'clients',
        title: this.$t('trial.headings.used'),
        dataClass: 'text-center',
        titleClass: 'text-center',
      }, {
        name: 'expiration_date',
        title: this.$t('trial.headings.expirationDate'),
        width: '15%',
        callback (value) {
          return value ? moment(value).format('DD/MM/YYYY HH:mm') : ''
        },
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
        titleClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('trials')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.trials.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
